import { Histogram } from "@/core/histogram"

const drawChannel = (
	ctx: CanvasRenderingContext2D,
	width: number,
	height: number,
	channel: Float32Array,
	maxValue: number,
	strokeColor: string,
	fillColor: string,
) => {
	const xStep = width / Histogram.Range
	ctx.strokeStyle = `hsl(${strokeColor})`
	ctx.fillStyle = fillColor
	ctx.beginPath()
	ctx.moveTo(0, height)
	let last_c = 0
	const drawSample = 1

	for (let i = 0; i < Histogram.Range; i += drawSample) {
		const c = channel[i] ?? 0
		const x = i * xStep
		if (last_c === 0 && c !== 0) {
			ctx.moveTo(x, height)
		}
		const n = c / maxValue
		const y = height - n * height
		const skipDraw = last_c === 0 && c === 0 // don't draw the bottom line

		if (!skipDraw) {
			ctx.lineTo(x, y)
		}
		// force check and draw the last point
		if (drawSample > 1 && i !== Histogram.Range - 1) {
			if (i + drawSample >= Histogram.Range) {
				i = Histogram.Range - drawSample
			}
		}
		last_c = c
	}

	// ctx.closePath() // the line makes the polyline rough
	ctx.stroke()
	ctx.fill()
}

export const drawHistogram = (
	canvas: HTMLCanvasElement | null,
	red: Float32Array,
	green: Float32Array,
	blue: Float32Array,
	max: number,
) => {
	if (!canvas) {
		return
	}

	const screenScale = window.devicePixelRatio || 1
	const ctx = canvas.getContext("2d")

	if (!ctx) {
		return
	}

	const rect = canvas.getBoundingClientRect()
	canvas.width = rect.width * screenScale
	canvas.height = rect.height * screenScale
	canvas.style.width = rect.width + "px"
	canvas.style.height = rect.height + "px"
	ctx.scale(screenScale, screenScale)

	const [width, height] = [canvas.width / screenScale, canvas.height / screenScale]

	// draw
	ctx.clearRect(0, 0, width, height)
	ctx.lineWidth = 2
	ctx.lineCap = "round"
	ctx.lineJoin = "round"

	drawChannel(ctx, width, height, red, max, "360, 50%, 50%", "rgba(205,120,120,40%)")
	drawChannel(ctx, width, height, green, max, "120, 50%, 50%", "rgba(120,205,120,40%)")
	drawChannel(ctx, width, height, blue, max, "230, 50%, 50%", "rgba(120,120,205,40%)")
}
